import React from 'react'
import Modal from '../Modal'
import CloseIcon from '../../assets/icon/CloseIcon'
import styles from './index.module.scss'

export type WorkspaceRequiredFeature = 'project' | 'participants'

interface WorkspaceRequiredModalProps {
    isOpen: boolean
    feature: WorkspaceRequiredFeature
    onClose: () => void
    onCreateWorkspace: () => void
}

const messages: Record<WorkspaceRequiredFeature, string> = {
    project: 'Для створення проєкту необхідно спочатку створити робочий простір.',
    participants: 'Для перегляду та запрошення учасників необхідно спочатку створити робочий простір.',
}

export default function WorkspaceRequiredModal({
    isOpen,
    feature,
    onClose,
    onCreateWorkspace,
}: WorkspaceRequiredModalProps) {
    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={onClose}
            contentLabel="Потрібен робочий простір"
            width={446}
        >
            <div className={styles.workspaceRequired}>
                <button
                    type="button"
                    className={styles.workspaceRequired__close}
                    onClick={onClose}
                    aria-label="Закрити"
                >
                    <CloseIcon />
                </button>
                <div className={styles.workspaceRequired__icon} aria-hidden="true">РП</div>
                <h2 className={styles.workspaceRequired__title}>Потрібен робочий простір</h2>
                <p className={styles.workspaceRequired__text}>{messages[feature]}</p>
                <div className={styles.workspaceRequired__actions}>
                    <button type="button" className={styles.workspaceRequired__cancel} onClick={onClose}>
                        Скасувати
                    </button>
                    <button type="button" className={styles.workspaceRequired__create} onClick={onCreateWorkspace}>
                        Створити робочий простір
                    </button>
                </div>
            </div>
        </Modal>
    )
}
